import TableBody from '@mui/material/TableBody';
import { isEmpty } from 'lodash';
import { observer } from 'mobx-react';
import * as React from 'react';
import shortid from 'shortid';

import { Show } from 'components/Condition';
import { Spinner } from 'components/Spinner';
import { Table as TableComponent } from 'components/Table';
import { TableEmptyListNotification } from 'components/TableEmptyListNotification';

import { t } from 'utils';

import { progressStore } from 'stores';

import { LOAD_COPY_RACERS } from '../../constants';

import { CopyRacersContext } from '../../context';
import { CopyRacersTable as RacerType } from '../../types';
import { THead } from '../THead';
import { Row } from './Row';

type Props = {};

@observer
class Table extends React.Component<Props> {
  static contextType = CopyRacersContext;
  declare context: React.ContextType<typeof CopyRacersContext>;

  render() {
    const copyRacersList: Array<RacerType> = this.context.results.stores.racersStore.values;

    return (
      <div className='component-list racers-list non-sticky'>
        <Show if={!isEmpty(copyRacersList)}>
          <TableComponent>
            <THead />
            {!progressStore.isLoading(LOAD_COPY_RACERS) && (
              <TableBody>
                {copyRacersList.map<React.ReactNode>((el) => (
                  <Row item={el} key={shortid()} />
                ))}
              </TableBody>
            )}
          </TableComponent>
        </Show>
        <Show if={isEmpty(copyRacersList)}>
          <TableEmptyListNotification text={t.staticAsString('supportTaskManager.noData')} />
        </Show>
        {progressStore.isLoading(LOAD_COPY_RACERS) && <Spinner type={Spinner.types.default} />}
      </div>
    );
  }
}

export { Table };
